import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_CANCEL_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationCaseCancel($id: UUID!, $data: TsrctNegotiationCaseCancelInput!) {
    tesseract {
      negotiationCase(id: $id) {
        cancel(data: $data)
      }
    }
  }
`);
